<template>
    <div>
        <div class="container-fluid pt-4">
            <b-modal id="StoreAlertEdit" title="Admin" @ok="close()" ok-only>
                <p class="my-4">{{ message }}</p>
            </b-modal>
            <b-modal id="StoreDeleteModal" title="Admin" @ok="deleteRow(id)">
                <p class="my-4">Are you sure you want to delete this slider?</p>
            </b-modal>
            <hr>
            <div class="row product-adding">
                <div class="col-xl-12">
                    <div class="row product-adding">
                        <div class="col-xl-6">
                            <div class="digital-add needs-validation">
                                <!-- Modules de la boutique : le blog et la boutique en
                                     ligne peuvent être activés séparément sur le site -->
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <h5 class="card-title">Store modules</h5>
                                        <div class="form-group mb-2">
                                            <b-form-checkbox switch size="s" v-model="form.blog">
                                                Active Blog</b-form-checkbox>
                                        </div>
                                        <div class="form-group mb-0">
                                            <b-form-checkbox switch size="s" v-model="form.shop">
                                                Active Shop</b-form-checkbox>
                                        </div>
                                    </div>
                                </div>

                                <!-- Couleurs de la boutique : une carte par groupe,
                                     avec le code hexadécimal affiché à côté de chaque
                                     sélecteur -->
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <h5 class="card-title">Store colors</h5>
                                        <div class="theme-color-row">
                                            <label for="Color1">Primary color</label>
                                            <div class="theme-color-input">
                                                <input id="Color1" type="color" v-model="form.color1" />
                                                <span class="theme-color-value">{{ form.color1 }}</span>
                                            </div>
                                        </div>
                                        <div class="theme-color-row">
                                            <label for="Color2">Secondary color</label>
                                            <div class="theme-color-input">
                                                <input id="Color2" type="color" v-model="form.color2" />
                                                <span class="theme-color-value">{{ form.color2 }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Couleurs des boutons : 4 états (normal, survol,
                                     actif, désactivé), 3 champs par état -->
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <h5 class="card-title">Button colors</h5>
                                        <div v-for="state in buttonStates" :key="state.label" class="theme-state">
                                            <h6 class="theme-section-title">{{ state.label }}</h6>
                                            <div v-for="field in state.fields" :key="field.key" class="theme-color-row">
                                                <label :for="field.id">{{ field.label }}</label>
                                                <div class="theme-color-input">
                                                    <input :id="field.id" type="color" v-model="form[field.key]" />
                                                    <span class="theme-color-value">{{ form[field.key] }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card mb-4">
                                    <div class="card-body">
                                        <h5 class="card-title">Products</h5>
                                        <div class="theme-color-row">
                                            <label for="backgroundColor">Product border color</label>
                                            <div class="theme-color-input">
                                                <input id="backgroundColor" type="color" v-model="form.ProductBorderColor" />
                                                <span class="theme-color-value">{{ form.ProductBorderColor }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Aperçu en direct : un bouton par état, avec les
                                     couleurs choisies ci-dessus -->
                                <div class="card">
                                    <div class="card-body">
                                        <h5 class="card-title">Live preview</h5>
                                        <p class="card-text text-muted mb-3">
                                            These buttons use the colors chosen above.
                                        </p>
                                        <div class="theme-preview">
                                            <button v-for="state in buttonStates" :key="state.label" type="button"
                                                class="btn" :style="previewStyle(state)"
                                                :disabled="state.label === 'Disabled'">
                                                {{ state.label }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="digital-add needs-validation">
                                <div class="form-group">
                                    <!--<div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.SingleProduct">This site use Single
                                            product only</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.affiliation">This site use
                                            Affiliate
                                            only</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.digital">
                                            This site use Digital products only</b-form-checkbox>
                                    </div>-->
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.showtopbar">Show
                                            Header notice
                                            bar</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <label for="validationstopbar" class="col-form-label pt-0">Header
                                            notice bar</label>
                                        <input class="form-control" id="validationstopbar" type="text"
                                            v-model="form.information" />
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.showbottombar">Show
                                            Footer notice
                                            bar</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <label for="validationsbottompbar" class="col-form-label pt-0">Foother
                                            notice bar</label>
                                        <input class="form-control" id="validationsbottompbar" type="text"
                                            v-model="form.footernoticebar" />
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.showslider">Show
                                            Slider in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.showreview">Show
                                            reviews</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.RelatedProducts">Show
                                            related
                                            products</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.RelatedArticles">Show
                                            related
                                            Articles</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.contact">Show
                                            Contact menu</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.indicator">Show
                                            Indicator in home
                                            page</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.catbanners">Show
                                            Categories banners in home
                                            page</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.toppicksproductsoftheweek">Show
                                            Top Picks Products Of The Week in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.customers">
                                            Show What Customers Say About Us in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.aboutus">
                                            Show section About Us in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.dealofftheweek">
                                            Show DEAL OFF THE WEEK in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.lastarrival">
                                            Show Latest Arrival in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.lastarticles">
                                            Show Latest Articles in home page
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.subscribe">
                                            Show section subscribe
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <b-form-checkbox switch size="s" v-model="form.dateofdelevery">Show
                                            date of delivery in order
                                            success</b-form-checkbox>
                                    </div>
                                    <div class="form-group">
                                        <label for="validationsAddToCartText" class="col-form-label pt-0">Add To Cart
                                            Text</label>
                                        <input class="form-control" id="validationsAddToCartText" type="text"
                                            v-model="form.AddToCartText" />
                                    </div>

                                    <!-- Hauteur du carrousel de la page d'accueil, en pixels,
                                         par taille d'écran. Enregistrée avec le reste du thème
                                         et appliquée par la vitrine (composant Slider2.ejs). -->
                                    <div class="card mt-4">
                                        <div class="card-body">
                                            <h5 class="card-title">Slider height</h5>
                                            <div class="theme-color-row">
                                                <label for="slider-height-desktop">Desktop</label>
                                                <div class="slider-height-input">
                                                    <input id="slider-height-desktop" class="form-control" type="number"
                                                        min="100" step="10" v-model.number="form.sliderheightdesktop" />
                                                    <span class="slider-height-unit">px</span>
                                                </div>
                                            </div>
                                            <div class="theme-color-row">
                                                <label for="slider-height-tablet">Tablet</label>
                                                <div class="slider-height-input">
                                                    <input id="slider-height-tablet" class="form-control" type="number"
                                                        min="100" step="10" v-model.number="form.sliderheighttablet" />
                                                    <span class="slider-height-unit">px</span>
                                                </div>
                                            </div>
                                            <div class="theme-color-row">
                                                <label for="slider-height-mobile">Mobile</label>
                                                <div class="slider-height-input">
                                                    <input id="slider-height-mobile" class="form-control" type="number"
                                                        min="100" step="10" v-model.number="form.sliderheightmobile" />
                                                    <span class="slider-height-unit">px</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 pb-3">
                    <div class="form-group mb-0">
                        <div class="product-buttons text-right">
                            <button type="button" class="btn btn-primary" @click="save">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
import firebase from '@/utils/firestore-shim';
import { uploadUrl, uploadHeaders } from './../../../utils/imageUpload';
import { VueEditor } from "vue2-editor";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Cookies from 'js-cookie';
export default {
    components: { VueEditor },
    data() {
        return {
            form: {},
            data: {},
            id: '',
            message: "",
            error: 0,
            // Sections de couleurs des boutons de la boutique : pour chaque
            // état, les trois champs texte / fond / bordure.
            buttonStates: [
                {
                    label: 'Normal',
                    fields: [
                        { id: 'btn-Color', label: 'Text color', key: 'BtnColor' },
                        { id: 'btn-bg-Color', label: 'Background color', key: 'BtnBgColor' },
                        { id: 'btn-border-color', label: 'Border color', key: 'BtnBorderColor' }
                    ]
                },
                {
                    label: 'Hover',
                    fields: [
                        { id: 'btn-hover-Color', label: 'Text color', key: 'BtnHoverColor' },
                        { id: 'btn-bg-hover-Color', label: 'Background color', key: 'BtnHoverBgColor' },
                        { id: 'btn-hover-border-color', label: 'Border color', key: 'BtnHoverBorderColor' }
                    ]
                },
                {
                    label: 'Active',
                    fields: [
                        { id: 'btn-active-Color', label: 'Text color', key: 'BtnActiveColor' },
                        { id: 'btn-bg-active-Color', label: 'Background color', key: 'BtnActiveBgColor' },
                        { id: 'btn-active-border-color', label: 'Border color', key: 'BtnActiveBorderColor' }
                    ]
                },
                {
                    label: 'Disabled',
                    fields: [
                        { id: 'btn-disabled-Color', label: 'Text color', key: 'BtnDisabledColor' },
                        { id: 'btn-bg-disabled-Color', label: 'Background color', key: 'BtnDisabledBgColor' },
                        { id: 'btn-disabled-border-color', label: 'Border color', key: 'BtnDisabledBorderColor' }
                    ]
                }
            ],
            editor: ClassicEditor,
            tablefields: [
                { key: "image", label: "Image", sortable: false },
                { key: "actions" }
            ],
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            sliders: [],
            categories: [],
            slider: "",
            sliderid: "",
            index: null,
            selectMode: "single",
            ImagesEditLogoOptions: {
                url: uploadUrl,
                headers: uploadHeaders(),
                thumbnailWidth: 300,
                thumbnailHeight: 70,
                maxFiles: 1,
                params: null,
                maxfilesexceeded: function (file) {
                    this.removeAllFiles();
                    this.addFile(file);
                },
                accept: function (file, done) {
                    done();
                },
                init: function () {
                    this.removeAllFiles();
                    let image = this.options.params;
                    let f = {
                        size: '12300',
                        name: 'logo',
                        dataURL: image,
                    };
                    this.files.push(f);
                    this.emit("addedfile", f);
                    this.emit("thumbnail", f, f.dataURL);
                    this.emit("complete", f);
                    this.on("removedfile", function (file) {
                        return null;
                    });
                },
                maxFilesize: 100,
                addRemoveLinks: true,
                uploadMultiple: false,
                maxThumbnailFilesize: 20,
                dictDefaultMessage:
                    "<i class='icon-cloud-up'></i><h6>Drop files here or click to upload. 150 x 50 px</h6><</span>",
            },
        };
    },
    computed: {
        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        },
        selectedRows() {
            return this.form.sliders.filter(item => item.delete);
        }
    },
    async mounted() {
        var data = await this.getStoresData();
        this.form = data[0];
        this.ensureThemeFields();
        this.sliders = data[0].sliders;
        this.categories = data[0].categories;
        this.ImagesEditLogoOptions.params = this.form.logo;
    },
    methods: {
        // Vue 2 ne rend pas réactives les propriétés ajoutées après coup :
        // on s'assure que tous les champs du thème existent dans form.
        ensureThemeFields() {
            const themeFields = [
                'color1', 'color2', 'ProductBorderColor',
                'BtnColor', 'BtnBgColor', 'BtnBorderColor',
                'BtnHoverColor', 'BtnHoverBgColor', 'BtnHoverBorderColor',
                'BtnActiveColor', 'BtnActiveBgColor', 'BtnActiveBorderColor',
                'BtnDisabledColor', 'BtnDisabledBgColor', 'BtnDisabledBorderColor'
            ];
            themeFields.forEach(key => {
                if (this.form[key] === undefined) {
                    this.$set(this.form, key, '#000000');
                }
            });
            // Interrupteurs blog / shop : un champ absent du document
            // Firestore doit exister pour que la case soit réactive au clic.
            ['blog', 'shop'].forEach(key => {
                if (this.form[key] === undefined) {
                    this.$set(this.form, key, false);
                }
            });
            // Hauteur du carrousel d'accueil (px) : même valeur de repli
            // (440) que celle utilisée par la vitrine.
            ['sliderheightdesktop', 'sliderheighttablet', 'sliderheightmobile'].forEach(key => {
                if (this.form[key] === undefined) {
                    this.$set(this.form, key, 440);
                }
            });
        },
        // Aperçu d'un état du bouton : texte / fond / bordure (l'ordre des
        // champs est défini dans buttonStates).
        previewStyle(state) {
            return {
                color: this.form[state.fields[0].key],
                backgroundColor: this.form[state.fields[1].key],
                borderColor: this.form[state.fields[2].key]
            };
        },
        async save() {
            if ((this.form.title == "") || (this.form.host == "") || (this.form.logo == "") || (this.form.symbol == "") || (this.form.rate == "")) {
                this.message = "Please complete all required fields!";
                this.error = 1;
                this.$bvModal.show('StoreAlertEdit');
                return false;
            } else {
                this.error = 0;
            }
            // La page Thème ne touche ni aux sliders ni aux catégories :
            // ils sont modifiés sur leurs propres pages. On les exclut de
            // l'écriture pour ne pas écraser des changements faits
            // entre-temps (couleurs des sliders, etc.).
            const payload = Object.assign({}, this.form);
            delete payload.sliders;
            delete payload.categories;
            let ref = await firebase.firestore().collection('Sites').doc(this.form.host).update(payload)
                .then(() => {
                    this.message = "Document successfully written!";
                    this.error = 0;
                    this.$bvModal.show('StoreAlertEdit');
                })
                .catch((error) => {
                    this.message = "Error writing document: " + error;
                    this.error = 1;
                    this.$bvModal.show('StoreAlertEdit');
                });
        },
        close() {
            if (this.error == 0) this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        back() {
            this.$bvModal.hide('modal-StoreEdit' + this.id);
        },
        getIndex(id) {
            this.sliderid = id;
        },
        async deleteRow(id) {
            this.form.sliders.splice(id, 1);
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        formData(e) {
            this.sliders.push(e);
        },
        updateformData(e) {
            this.sliders[e.id] = e;
            this.$refs.tableSlider.refresh();
        },
        uploadComplete(file) {
            Promise.all([this.get_url(this.dataURItoBlob(file.dataURL), file.name)])
                .then((res) => {
                    this.form.logo = res[0];
                });
        },
        fileRemoved() {

        },
        uploadSuccess() {

        },
        imageResize(base64Str) {
            var img = new Image();
            img.src = base64Str;
            var canvas = document.createElement('canvas');
            var MAX_WIDTH = 300;
            var MAX_HEIGHT = 50;
            var width = img.width;
            var height = img.height;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            return canvas.toDataURL();
        },
        showmodal() {
            this.$bvModal.show('modal-StoreEdit' + this.id);
        },
        async getStoresData() {
            let listData = [];
            var ProductRef = await firebase.firestore().collection("Sites")
                .where("host", "==", this.getStore())
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        this.id = doc.id;
                        listData.push(
                            doc.data()
                        );
                    });
                });
            return listData;

        },
        onFileChange(event) {
            let picture = event.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(picture);
            reader.onloadend = (e) => {
                this.form.logo = e.target.result;
            };
        },
        clear() {
            this.form = {};
            this.sliders = [];
        },
        ok(e) {
            this.form.categories = e;
        },
        dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(',')[1]);
            var blob;
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: 'image/png' });
        },
        async get_url(file, filename) {
            // Téléversement vers l'API Hermes (stockage sur le disque du
            // serveur, dossier api/uploads) : remplace Firebase Storage
            // dont le bucket a dépassé le quota du plan gratuit Spark.
            if (!file) {
                return null;
            }
            const safeName = String(filename || 'logo').replace(/[#\[\]*?]/g, '-');
            const ext = file.type === 'image/png' ? '.png' : '.webp';
            const form = new FormData();
            form.append('folder', 'sites/' + this.form.host + '/logo');
            form.append('file', file, safeName + ext);
            const res = await fetch(uploadUrl, { method: 'POST', headers: uploadHeaders(), body: form });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.error || 'Erreur ' + res.status + ' : /api/uploads injoignable (API Hermes démarrée ? proxy /api actif ?)');
            return data.url;
        },
        getStore() {
            const host = Cookies.get('hostCookie');
            if (host) {
                return host;
            } else {
                this.$router.push('/dashboard/default');
            }
        }
    }
};
</script>
<style lang="scss" scoped>
table.text-center * {
    text-align: center;
}

/* Colonne des couleurs : libellé à gauche, sélecteur et code
   hexadécimal à droite, sur une même ligne bien alignée */
.theme-color-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.35rem 0;

    label {
        margin-bottom: 0;
    }
}

.theme-color-input {
    display: flex;
    align-items: center;
}

.theme-color-value {
    margin-left: 0.5rem;
    min-width: 4.5rem;
    font-family: monospace;
    font-size: 0.8rem;
}

/* Sélecteur de couleur un peu plus grand que le champ natif */
input[type="color"] {
    width: 3.25rem;
    height: 2rem;
    padding: 0.15rem;
    border: 1px solid #e6e2e6;
    border-radius: 0.25rem;
    background-color: #fff;
    cursor: pointer;
}

/* Séparation entre les états des boutons (Normal, Hover...) */
.theme-state + .theme-state {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px dashed #e9ecef;
}

.theme-section-title {
    margin-bottom: 0.25rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #a9a7ac;
}

/* Aperçu des boutons */
.theme-preview {
    display: flex;
    flex-wrap: wrap;

    .btn {
        margin: 0 0.5rem 0.5rem 0;
        cursor: default;
    }
}

/* Hauteur du slider : champ numérique aligné à droite avec l'unité px */
.slider-height-input {
    display: flex;
    align-items: center;

    .form-control {
        width: 6.5rem;
        text-align: right;
    }
}

.slider-height-unit {
    margin-left: 0.5rem;
    color: #a9a7ac;
    font-size: 0.85rem;
}
</style>